// extracted by mini-css-extract-plugin
module.exports = {"asterisk":"RequiredAsterisk_asterisk__PHoC8"};